/**
 * @ignore
 * User: daletan
 * Date: 3/13/16
 * Time: 6:42 PM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 */

'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const OverlaySpinner = require("./OverlaySpinner");
const overlayStyles = require('./_spinner.scss');

class Overlay {
    /**
     * Create the offset left as a percentage for the element
     * Attached as a private method for testing
     * @param {object} options
     * @param {number} options.containerWidth
     * @param {number} options.elementWidth
     * @param {number} [options.offsetLeft]
     * @returns {number}
     * @private
     */
    _calcOffsetLeft(options = {}) {
        const { containerWidth = 0, offsetLeft = 0, elementWidth = 0 } = options;

        const targetWidth = containerWidth - offsetLeft;
        const targetCenter = targetWidth / 2;
        const elementCenter = elementWidth / 2;
        const elementLeft = (targetCenter - elementCenter) + offsetLeft;

        // turn this into a usable percentage
        return 100 * (elementLeft / containerWidth);
    }
    /**
     * Create the offset top as a pixel for the element
     * Attached as a private method for testing
     * @param {object} options
     * @param {number} options.containerHeight
     * @param {number} options.elementHeight
     * @param {number} [options.offsetTop]
     * @returns {number}
     * @private
     */
    _calcOffsetTop(options = {}) {
        const { containerHeight = 0, offsetTop = 0, elementHeight = 0 } = options;
        const adjustmentHeight = elementHeight / 2;
        return ((containerHeight - offsetTop) / 2) - adjustmentHeight + offsetTop;
    }
    /**
     * Readjust the spinner to be positioned relative
     * to the container dimensions
     *
     * HACK:
     * have to do this calculation here since
     * `componentDidMount` doesn't paint the DOM
     * with elements yet so you cannot access
     * dimensions of the element
     *
     * @private
     * @param {number} [options.leftOffset]
     * @param {number} [options.topOffset]
     * @param {number} [options.containerWidth]
     * @param {number} [options.containerHeight]
     */
    _adjustSpinner(options) {
        const { offsetLeft = 0, offsetTop = 0, containerWidth = 0, containerHeight = 0 } = options;
        const $spinner = this._parent.querySelector('.' + overlayStyles.spinner);
        if ($spinner) {
            const left = this._calcOffsetLeft({
                containerWidth,
                offsetLeft,
                // use offsetWidth to compensate for borders
                elementWidth: $spinner.offsetWidth
            });
            const top = this._calcOffsetTop({
                containerHeight,
                offsetTop,
                // use offsetWidth to compensate for borders
                elementHeight: $spinner.offsetHeight
            });

            this._positionSpinner($spinner, left, top);
        }
    }

    /**
     *
     * @param {DOMElement} $spinner The spinner element itself
     * @param {number} left The left position of the element as a percentage
     * @param {number} top The top position of the element as a pixel
     * @private
     */
    _positionSpinner($spinner, left, top) {
        $spinner.style.left = `${left}%`;
        $spinner.style.top = `${top}px`;
    }

    /**
     *
     * @param parent
     * @private
     */
    _setParent({ parent = null }) {
        this._parent = parent;
    }
    /**
     * @see this._adjustSpinner
     * @param {object} options
     * @param {HTMLElement} options.parent
     * @param {object} [options.componentOptions]
     */
    show(options) {
        this._setParent(options);
        if (this._parent instanceof HTMLElement && global && global.document) {
            ReactDOM.render(
                React.createElement(OverlaySpinner, options.componentOptions || {}),
                this._parent
            );
            this._parent.style.display = 'block';
            this._adjustSpinner(options);
        }
    }
    hide() {
        if (this._parent instanceof HTMLElement) {
            ReactDOM.unmountComponentAtNode(this._parent);
            this._parent.style.display = 'none';
            this._parent = null;
        }
    }

}

module.exports = Overlay;



// WEBPACK FOOTER //
// ./assets/js/components/OverlaySpinner/OverlaySpinnerWrapper.es.js